import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import PropTypes from 'prop-types';
import errorIcon from './images/error.svg';
import './FamilyBundleErrorPopup.scss';

function FamilyBundleErrorPopup({
    errorType = 'flightManager', // 'flightManager', 'members', 'cellularOff', 'hasFamilySoc'
    flightManager = {},
    failedMembers = [],
    onSelectDifferentFlightManager = () => { },
    onContinueWithRest = () => { },
    onCancelPackage = () => { },
    onClose = () => { },
    onTurnOnCellularData = () => { },
    onSelectAnotherPackage = () => { },
}) {

    const renderFlightManagerError = () => (
        <>
            <div className='popup-text'>
                <Image src={errorIcon} alt="error" className="popup-icon" />
                <h2 className="popup-title">
                    לא ניתן להגדיר את {flightManager.phone} {flightManager.name ? `(${flightManager.name}) ` : ''}כמנהל טיסה
                </h2>
            </div>
            <div className="popup-buttons">
                <button className="continue-btn" onClick={() => { onSelectDifferentFlightManager(); onClose(); }}>
                    בחירת מנהל טיסה אחר
                </button>
            </div>
        </>
    );

    const renderMembersError = () => (
        <>
            <div className='popup-text'>
                <Image src={errorIcon} alt="error" className="popup-icon" />
                <h2 className="popup-title">
                    ההתקנה לא הצליחה
                    <span className="desktop-only-br"><br /></span>
                    עבור חלק מהמנויים
                </h2>
                <p className="popup-description">
                    ייתכן וקיימת להם חבילה אחרת שלא ניתן להתקין יחד עם החבילה המשפחתית
                </p>
            </div>

            <div className="failed-members-list">
                {failedMembers.map((member, index) => (
                    <div key={index} className="failed-member-row">
                        <span className="member-phone">{member}</span>
                        {/* {member.name && <span className="member-name">{member.name}</span>} */}
                    </div>
                ))}
            </div>

            <div className="popup-buttons">
                <button className="continue-btn" onClick={() => { onContinueWithRest(); onClose(); }}>
                    הבנתי, בואו נמשיך
                </button>

                <button className="secondary-btn" onClick={() => { onCancelPackage(); onClose(); }}>
                    ביטול החבילה
                </button>
            </div>
        </>
    );

    const handleTurnOnCellularDataForFailedMembers = () => {
        onTurnOnCellularData(failedMembers || []);
        onClose();
    };

    const renderCellularDataOffError = () => (
        <>
            <div className='popup-text'>
                <Image src={errorIcon} alt="error" className="popup-icon" />
                <h2 className="popup-title">
                    שמנו לב שמוגדרת חסימת
                    <span className="desktop-only-br"><br /></span>
                    גלישה למנויים הבאים
                </h2>
            </div>
            <div className='failed-members-list'>
                {failedMembers.map((member, index) => (
                    <div key={index} className="failed-member-row">
                        <span className="member-phone">{member}</span>
                        {/* {member.name && <span className="member-name">{member.name}</span>} */}
                    </div>
                ))}
            </div>
            <div className="popup-buttons">
                <button className="continue-btn" onClick={() => { onContinueWithRest(); onClose(); }}>
                    תשאירו את חסימת הגלישה
                </button>
                <button className="secondary-btn" onClick={handleTurnOnCellularDataForFailedMembers}>
                    הסירו את חסימת הגלישה
                </button>
            </div>
        </>
    );

    const renderHasFamilySocError = () => (
        <>
            <div className='popup-text'>
                <Image src={errorIcon} alt="error" className="popup-icon" />
                <h2 className="popup-title">
                     אחד המנויים כבר משויך{' '}
                    <span className="desktop-only-br"><br /></span>
                    לחבילה משפחתית אחרת 
                </h2>
                <p className="popup-description">
                    נא לבחור חבילה אחרת
                </p>
            </div>
            <div className="popup-buttons">
                <button className="continue-btn" onClick={() => { onSelectAnotherPackage(); onClose(); }}>
                    בחר חבילה אחרת
                </button>
            </div>
        </>
    );

    return (
        <div className="family-bundle-error-popup" role="dialog" aria-modal="true">
            {errorType === 'flightManager' && renderFlightManagerError()}
            {errorType === 'members' && renderMembersError()}
            {errorType === 'cellularOff' && renderCellularDataOffError()}
            {errorType === 'hasFamilySoc' && renderHasFamilySocError()}
        </div>
    );
}

FamilyBundleErrorPopup.propTypes = {
    errorType: PropTypes.oneOf(['flightManager', 'members', 'cellularOff', 'hasFamilySoc']),
    flightManager: PropTypes.object,
    failedMembers: PropTypes.arrayOf(PropTypes.object),
    onSelectDifferentFlightManager: PropTypes.func,
    onContinueWithRest: PropTypes.func,
    onCancelPackage: PropTypes.func,
    onClose: PropTypes.func,
    onTurnOnCellularData: PropTypes.func,
    onSelectAnotherPackage: PropTypes.func,
};

export default FamilyBundleErrorPopup;
